<div class="container-box" *ngIf="fanDetails !== null">
  <!--Body block starts-->
  <div>
    <h1>Buy a product using a different wireless number</h1>
  </div>
  <!-- Error Block -->
  <div class="error-container" aria-live="assertive">
    <div class="alert valign-children-middle" *ngIf='setError'>
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <h2 *ngIf='licenseErrorFlag' >{{licenseError}}</h2>
        <h2 *ngIf='banFlag'>Valid account number needed</h2>
        <p>{{ErrorMessage}}</p>
      </div>
    </div>
    <div class="alert valign-children-middle" *ngIf='invalidFan'>
      <div class="alert-info" aria-label="Info.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>{{fanMessage}}</div>
    </div>
  </div>
  <!-- Error Block End -->
  <p><label class="data-label">Selected product:</label> {{ fanDetails.key }}</p>
  <form [formGroup]="buyProductForm" autocomplete="off">
    <!-- Foundation Block -->
    <div *ngIf='fanScetion'>
      <div class="row" *ngIf='showFanDropDown'>
        <!-- Foundation No Selection -->
        <label class="col-md-12 col-sm-12" for="fandropdown">Foundation account number</label>
        <div class="col-sm-12 col-md-4 fan-down">
          <app-dropdown [labelId]="'fandropdown'" [options]="fanNumbers" [placeholder]="dropDownPlaceholder" (selectEmit)="selected($event, 'fan')"></app-dropdown>
        </div>
        <div class="col-sm-12 col-md-3">
          <button class="btn btn-secondary btn-go" (click)="selectGoFan()">  Go  </button>
        </div>
      </div>
      <!-- Foundation Selection End -->

      <div class="row" *ngIf='!showFanDropDown'>
        <!-- Foundation After Selection -->
        <label class="col-md-12 col-sm-12">Foundation account number</label>
        <div class="col-sm-12 col-md-12">
          <p><strong>{{shownFan}}</strong><span class="separator" *ngIf='editFbtn'> | </span><a *ngIf='editFbtn' href="javascript:void(0);"
              (click)='editFan()'>Edit</a></p>
        </div>
      </div>
    </div>
    <!-- Foundation After Selection End -->
    <!-- Foundation Block End -->

    <div *ngIf='banSectionEnable'>
      <!-- Billing Block Start -->

      <div class="row" *ngIf='showBanDropDown && !banField'>
        <!-- Billing Account-->
        <label for="ban_input" class="col-md-12 col-sm-12">Billing account</label>
        <div class="col-sm-12 col-md-4">
          <app-dropdown [attr.aria-describedby]="formErrors.ban ? 'ban-error' : null" [labelId]="'ban_input'" [options]="banNumbers"
            [placeholder]="dropbanDownPlaceholder" (selectEmit)="selected($event, 'ban')"></app-dropdown>
        </div>
        <div class="col-sm-12 col-md-3">
          <button aria-label="Go." class="btn btn-secondary btn-go" (click)='checkBanEntered()'>  Go  </button>
        </div>
        <div id="ban-error" *ngIf="formErrors.ban" class="text-danger marleft-20" tabindex="0">
          {{ formErrors.ban }}
        </div>
      </div>
      <!-- Billing Account text field section-->
      <div class="form-group" *ngIf='showBanDropDown && banField'>
        <label for="ban_input" class="col-md-12 col-sm-12">Billing account</label>
        <div class="col-sm-12 col-md-4">
          <div class="search">
            <input type="search" id='ban_input' [attr.aria-describedby]="formErrors.ban ? 'ban-error-field' : null" maxlength="12" class="form-control"
              [class.text-error]="formErrors.ban" placeholder="Search" formControlName="ban">
            <span class="search-icon" aria-label="Search" (keypress)='checkBanEntered($event)' (click)='checkBanEntered()'><i tabindex="0" aria-hidden="true" class ="icon-controls-magnifyingglass"> </i> </span>
          </div>
          <div id="ban-error-field" *ngIf="formErrors.ban" class="text-danger marleft-20" tabindex="0">
            {{ formErrors.ban }}
          </div>
        </div>
        <div class="col-sm-12 col-md-3">
          <button class="btn btn-secondary btn-go" (click)='checkBanEntered()' aria-label="Go." [disabled]="buyProductForm.controls.ban.status === 'INVALID'">  Go  </button>
        </div>
      </div>
      <!-- Billing Account text field section End-->

      <div class="row" *ngIf='!showBanDropDown'>
        <!-- Billing After Selection -->
        <label class="col-md-12 col-sm-12">Billing account</label>
        <div class="col-sm-12 col-md-12">
          <p><strong>{{showBan}}</strong><span class="separator" *ngIf='editBbtn'> | </span><a *ngIf='editBbtn' (click)='editBan()' href="javascript:void(0);">Edit</a></p>
        </div>
      </div>
      <!-- Billing After Selection End -->
      <!-- Billing Block End -->
    </div>
    <!-- Wireless Selection Start -->
    <div *ngIf='ctnSectionEnable'>
      <div class="form-group" *ngIf='showCtnDropDown'>
        <!-- Wireless Account-->
        <label for="ctninput" class="col-md-12 col-sm-12">Wireless number</label>
        <div class="col-sm-12 col-md-4">
          <div class="search">
            <input type="search" id='ctninput' [attr.aria-describedby]="formErrors.ctn ? 'ctn-error' : null" maxlength="12" (change)='ctnChange($event)'
              (focus)='ctnFocus($event)' (blur)='ctnBlur($event)' class="form-control" [class.text-error]="formErrors.ctn"
              placeholder="Search" formControlName="ctn">
            <span class="search-icon" (keypress)='matchCtn($event)' (click)='matchCtn()'><i tabindex="0" class = "icon-controls-magnifyingglass" aria-label="Begin search."> </i> </span>
          </div>
          <div id="ctn-error" *ngIf="formErrors.ctn" class="text-danger marleft-20" tabindex="0">
            {{ formErrors.ctn }}
          </div>
        </div>
        <div class="col-sm-12 col-md-3">
          <button class="btn btn-secondary btn-go" (click)='matchCtn()' aria-label="Go." [disabled]="buyProductForm.controls.ctn.status === 'INVALID'">  Go  </button>
        </div>
      </div>

      <div class="row" *ngIf='!showCtnDropDown'>
        <!-- Wireless After Selection -->
        <label class="col-md-12 col-sm-12 data-label">Wireless number</label>
        <div class="col-sm-12 col-md-12">
          <p x-ms-format-detection="none"><strong>{{selectedCtn}}</strong><span class="separator" *ngIf='editCtntn'> | </span><a *ngIf='editCtntn' (click)='editCtn()'
              href="javascript:void(0);">Edit</a></p>
        </div>
      </div>
    </div>
    <!-- Wireless Account End -->

    <!-- Licenses add container-->
    <div class="lisence-container">
      <span>How many licenses would you like?</span>
      <div class="row">
        <div class="qty-block">
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm-12 col-md-5 volume-discount" *ngIf='showVolumeDiscount'>
                <label class="data-label">License price per month: </label>
                <div *ngFor="let item of volumeDiscount; let contentIndex = index">
                  <div *ngIf="contentIndex === 0">
                    {{item.amount | currency:'USD':true:'1.2-3'}} /license
                  </div>
                  <div *ngIf="feeType === 'Tiered' && contentIndex > 0">
                    {{item.amount | currency:'USD':true:'1.2-3'}} /user if > {{item.minQty - 1}}
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-12 margin-bot">
                <label for="enter-quantity" class="label-block" [ngClass]="{'error-field': formErrors.qty}">Number of licenses</label>
              </div>
              <div class="col-sm-12 col-md-4">
                <div class="form-group">
                  <div class="col-sm-7 col-md-6">
                    <input id="enter-quantity" [attr.aria-describedby]="formErrors.qty ? 'add-qty-error': null" aria-label="Enter the number of licenses to buy."
                      type="text" class="form-control mar-top5" [class.text-error]="formErrors.qty" formControlName="qty" maxlength="5">
                  </div>
                  <div class="col-sm-5 col-md-2 pad-left-0">
                    <button type="button" class="btn btn-secondary btn-update btn-sm" (click)='getUpdatedPricing()' aria-label="Update." [disabled]="buyProductForm.controls.qty.status === 'INVALID'">Update</button>
                  </div>
                  <div id="add-qty-error" *ngIf="formErrors.qty" class="text-danger col-sm-12 col-md-10 qty-error" tabindex="0">
                    {{ formErrors.qty }}
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Licenses add container end block-->
  </form>

  <div class='singeline totalcontainer'>
    <div class='row'>
      <!-- <div class='col-md-7 col-sm-12'>
        <h3 class="heading-bold">Total charges*</h3>
        <div *ngIf='showVolumeDiscount'>{{UpdatedQtyCount}} <span [innerHTML]="(UpdatedQtyCount > 1)? 'licenses':'license'"></span> &#64; {{ unitPrice | currency:'USD':true:'1.2-3'
          }}/user</div>
      </div> -->
      <div class='col-sm-10 col-md-5 radio-margin'>
        <div class="price-detail">
          <p class="price-value">{{ UpdatedQtyAmt | currency:'USD':true:'1.2-3' }} <span> /month </span> </p>
          <!-- <p class="per-month"> /month </p> -->
        </div>
      </div>
    </div>
  </div>
  <small>*Totals are based on estimated charges. Taxes and fees will be calculated for applicable charges. Charges will appear on your billing statement. You may not see any discounts or bill credits subtracted from your charges until you select your billing account on the <strong>Checkout</strong> page.</small>

  <hr class="cart-hr hide-sm" />
  <div class='text-right checkout-cta'>
    <button type="button" class="btn btn-success btn-cart pull-right" (click)="checkOutOrder()" [disabled]="!buyProductForm.valid || !ctnMatch || !priceCountValidated"
      aria-label="Check out">Check out</button>
    <a class="btn btn-link btn-cart" routerLink="/manage">Cancel</a>
  </div>
  <!--Body block ends-->
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>